import { render, staticRenderFns } from "./LuaEditor.vue?vue&type=template&id=7ad4c75a&scoped=true&"
import script from "./LuaEditor.vue?vue&type=script&lang=js&"
export * from "./LuaEditor.vue?vue&type=script&lang=js&"
import style0 from "./LuaEditor.vue?vue&type=style&index=0&id=7ad4c75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4c75a",
  null
  
)

export default component.exports